/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Booking_Pack_PriceInputs */

const en_features_booking_pack_price = /** @type {(inputs: Features_Booking_Pack_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€360`)
};

const pl_features_booking_pack_price = /** @type {(inputs: Features_Booking_Pack_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1350 zł`)
};

/**
* | output |
* | --- |
* | "€360" |
*
* @param {Features_Booking_Pack_PriceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_pack_price = /** @type {((inputs?: Features_Booking_Pack_PriceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_Pack_PriceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_pack_price(inputs)
	return en_features_booking_pack_price(inputs)
});